import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";
import { extractApiErrorMessage } from "@/utils/apiErrorUtils";

const getUxStore = () => useUxStore();

function shouldStoreAsOpenOffice(fileName) {
  const name = (fileName || "").toLowerCase();
  return name.endsWith(".odt") || name.endsWith(".ott") || name.endsWith(".docx");
}

export default {
  async uploadInvoiceDocument(file) {
    if (!file) {
      throw new Error("No file selected for upload.");
    }

    const formData = new FormData();
    formData.append("file", file);

    const url = shouldStoreAsOpenOffice(file.name)
      ? "/file/upload?fileKind=OPENOFFICE"
      : "/file/upload";

    try {
      getUxStore().startLoading();
      return await apiClient.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      console.error("Error in InvoiceDocumentService.uploadInvoiceDocument:", error);
      getUxStore().setError("Fehler beim Hochladen des Dokuments.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async importDocumentToZugferd(invoiceId, payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/invoice/${invoiceId}/import/document/to-zugferd`, payload);
    } catch (error) {
      console.error("Error in InvoiceDocumentService.importDocumentToZugferd:", error);
      getUxStore().setError(extractApiErrorMessage(error, "Fehler beim Import/der ZUGFeRD-Umwandlung."));
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
};

